export const environment = {
  production: false,
  auth: {
    identityPoolId: 'ca-central-1:df4a6de6-93c2-479e-ae12-b3fc8b469b8a',
    region: 'ca-central-1',
    userPoolId: 'ca-central-1_SwT2h3YrA',
    userPoolWebClientId: '17jpeuja3mh0m4u1c8o866g5pg'
  },
  API: {
    endpoints: [
      {
        name: 'API',
        endpoint: 'https://9cwjch5o8d.execute-api.ca-central-1.amazonaws.com/development/',
        region: 'ca-central-1'
      }
    ]
  }
};
